import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  networkListWithMasterId: [],
};

export const accumulatorSlice = createSlice({
  name: 'accumulator',
  initialState: INITIAL_STATE,
  reducers: {
    setNetworkList: (state, action) => {
      state.networkListWithMasterId = [
        ...state.networkListWithMasterId,
        ...action.payload,
      ];
    },
    resetNetworkList: (state) => {
      state.networkListWithMasterId = [];
    },
  },
});

//Action creators are generated for each case reducer function
export const { setNetworkList, resetNetworkList } = accumulatorSlice.actions;

export default accumulatorSlice.reducer;
